// isAnonymousMode returns true if we are in anonymous mode - where student names are replaced with
// fake names and sensitive information is blurred out
export const isAnonymousMode = () => window.name === 'ANONYMOUS_MODE';

// Open the page in a new window, with the target of 'ANONYMOUS_MODE'. This can be detected
// by the isAnonymousMode function above.
export const openAnonymousMode = () => window.open(window.location.href, 'ANONYMOUS_MODE');
